<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.subject_treemaps', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navLinks.gradeLevels" />
        </div>

        <div class="flex flex-wrap gap-x-2">
            <AppButton
                element="InertiaLink"
                :href="subject.url"
                v-for="subject in options.subjects"
                :key="subject.id"
                class="flex gap-x-2"
            >
                {{ subject.text }}

                <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.subject_id == subject.id" />
            </AppButton>
        </div>

        <form :action="meta.links.update" method="post" @submit.prevent="submit" v-if="filters.subject_id">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.title')" for="title" />
                            <FormInput
                                required
                                id="title"
                                v-model="form.title"
                                name="title"
                                type="text"
                                max="191"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.title" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.active')" for="is_active" />
                            <input
                                id="is_active"
                                type="checkbox"
                                v-model="form.is_active"
                                name="is_active"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            <FormError :value="form.errors.is_active" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.published_at')" for="published_at" />
                            <FormInput
                                required
                                id="published_at"
                                v-model="form.published_at"
                                name="published_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.published_at" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.unpublished_at')" for="unpublished_at" />
                            <FormInput
                                required
                                id="unpublished_at"
                                v-model="form.unpublished_at"
                                name="unpublished_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.unpublished_at" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="mt-5">
                <TreemapTagWeightForm :blocks="options.blocks" v-model="form.tags" />
            </div>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import TreemapTagWeightForm from './partials/TreemapTagWeightForm.vue';
import SubmitFormButton from '../Subactivities/SubmitFormButton.vue';
import SmartBreadcrumbs from '../../../../components/SmartBreadcrumbs.vue';
import NavLinks from '../../../../components/NavLinks.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import AppButton from '../../../../components/AppButton.vue';

export default {
    components: {
        AppButton,
        IconCircleCheckFilled,
        NavLinks,
        SmartBreadcrumbs,
        SubmitFormButton,
        TreemapTagWeightForm,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                is_active: true,
                title: '',
                published_at: '',
                unpublished_at: '',
                school_year_id: '',
                tags: [],
            }),
        };
    },
    methods: {
        submit() {
            this.form
                // .transform((data) => {
                //     const tags = data.tags;
                //
                //     return {
                //         ...data,
                //         tags: tags
                //             .flatMap((b) => b.sections)
                //             .flatMap((s) => s.tags)
                //             .map((tag) => {
                //                 return {
                //                     id: tag.id,
                //                     weight: tag.weight,
                //                 };
                //             })
                //             .filter((t) => t.weight > 0),
                //     };
                // })
                .post(this.meta.links.store);
        },
    },
};
</script>
